module.exports = __webpack_public_path__ + "static/email-marketing-automation-coffee-2b4166745b1870d817e486a42df4302f.svg";